export class File {
  id: bigint;
  name: string;
  type_id: number;
  description: string;
  path: string;
  state: string;
  order: number;
  active: boolean;
  date: any;
  code: Blob;
}
